import { widgets } from '@/helpers/consts';

export const THEME_APP_BLOCK_CONFIG = {
  [widgets.productReviewWidget]: [
    {
      handle: 'product-widget',
      type: 'block',
      template: 'product',
      target: 'newAppsSection',
      labelKey: 'Widgets.addToTheme',
    },
  ],
  [widgets.stars]: [
    {
      handle: 'product-stars',
      type: 'block',
      template: 'product',
      target: 'mainSection',
      labelKey: 'Widgets.enableProductStars',
    },
    {
      handle: 'list-stars',
      type: 'block',
      template: 'collection',
      target: 'mainSection',
      labelKey: 'Widgets.enableCollectionStars',
    },
  ],
  [widgets.carousel]: [
    {
      handle: 'carousel',
      type: 'block',
      template: 'index',
      target: 'newAppsSection',
      labelKey: 'Widgets.addToTheme',
    },
  ],
  [widgets.footerEmailBadge]: [
    {
      handle: 'footer-badge',
      type: 'block',
      template: 'index',
      target: 'footer',
      labelKey: 'Widgets.addToTheme',
    },
  ],
  [widgets.floatingWidget]: [
    {
      handle: 'global',
      type: 'embed',
      labelKey: 'Widgets.enableInThemeEditor',
    },
  ],
  [widgets.allReviewsPage]: [
    {
      handle: 'all-reviews',
      type: 'block',
      target: 'newAppsSection',
      labelKey: 'Widgets.addToTheme',
    },
  ],
  richSnippet: [
    {
      handle: 'rich-snippet',
      type: 'embed',
      labelKey: 'Widgets.enableInThemeEditor',
    },
  ],
};

export function buildThemeAppBlockUrl({ shopDomain, apiKey, handle, type, template, target }) {
  const base = `https://${shopDomain}/admin/themes/current/editor`;

  if (type === 'embed') {
    return `${base}?context=apps&activateAppId=${apiKey}/${handle}`;
  }

  const params = [];
  if (template) {
    params.push(`template=${template}`);
  }
  params.push(`addAppBlockId=${apiKey}/${handle}`);
  if (target) {
    params.push(`target=${target}`);
  }

  return `${base}?${params.join('&')}`;
}

export function getThemeAppBlockLinks({ widgetKey, shopDomain, apiKey, t }) {
  if (!widgetKey || !shopDomain || !apiKey) {
    return [];
  }

  const configs = THEME_APP_BLOCK_CONFIG[widgetKey];
  if (!configs) {
    return [];
  }

  return configs.map(config => ({
    label: t(config.labelKey),
    url: buildThemeAppBlockUrl({ shopDomain, apiKey, ...config }),
  }));
}

export function getThemeAppBlockConfigByHandle(handle) {
  return Object.values(THEME_APP_BLOCK_CONFIG)
    .flat()
    .find(config => config.handle === handle);
}

export function getThemeAppBlockDeepLink(handle, shopDomain, apiKey) {
  const config = getThemeAppBlockConfigByHandle(handle);
  if (!config || !shopDomain || !apiKey) {
    return null;
  }

  return buildThemeAppBlockUrl({ shopDomain, apiKey, ...config });
}
